<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'createTemplate',
})
</script>
<template>
    <a-modal title="对公转账审核" :width="1000" :open="true" :confirmLoading="state.loading" :maskClosable="false"
        @ok="onFormSubmit" @cancel="cancel">
        <template #footer>
            <a-button @click="cancel">取消</a-button>
            <a-popconfirm title="是否确定？" @confirm="onFormSubmit">
                <a-button type="primary" :loading="state.submitLoading">确定</a-button>
            </a-popconfirm>
        </template>
        <a-skeleton :loading="state.loading" active :paragraph="{ rows: 6 }">
            <a-form ref="ruleForm" :model="formState" v-bind="formLayout">
                <a-form-item label="类型">
                    <div v-if="props.detailData.kezhang_id">刻章-对公转账</div>
                    <div v-if="props.detailData.customer_id">地址-对公转账</div>
                </a-form-item>
                <a-form-item label="公司名称">
                    {{ props.detailData.customer_info.full_name }}
                </a-form-item>
                <div v-if="props.detailData.customer_id">
                    <a-form-item label="支付类型">
                        <span v-if="props.detailData.payment_type == 1">支付注册费</span>
                        <span v-if="props.detailData.payment_type == 2">地址续费</span>
                        <span v-if="props.detailData.payment_type == 3">其他收入</span>
                    </a-form-item>
                    <a-form-item label="收费类型">
                        <span v-if="props.detailData.fee_standard == 1">按年续费</span>
                        <span v-if="props.detailData.fee_standard == 2">一次性</span>
                    </a-form-item>
                    <a-form-item label="时长">
                        {{ props.detailData.month_amount }} 月
                    </a-form-item>
                </div>
                <a-form-item label="审核结果" required="true">
                    <a-radio-group v-model:value="formState.status" button-style="solid">
                        <a-radio :value="1">通过</a-radio>
                        <a-radio :value="2">不通过</a-radio>
                    </a-radio-group>
                </a-form-item>
                <a-form-item label="备注">
                    <a-textarea v-model:value="formState.remark" placeholder="请输入备注" style="width: 400px"></a-textarea>
                </a-form-item>
            </a-form>
        </a-skeleton>
    </a-modal>
</template>
<script lang="ts" setup name="createTemplate">
import { reactive, ref, onMounted, computed, handleError } from 'vue'
import { message } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import type { PaginationProps } from 'ant-design-vue'
import { useStore } from 'vuex'
const $store = useStore()
const emit = defineEmits(['ok', 'cancel'])
const props = defineProps({
    detailData: {
        type: Object,
        default: () => { }
    }
})
const formLayout = {
    labelCol: {
        xs: { span: 4 },
        sm: { span: 4 }
    },
    wrapperCol: {
        xs: { span: 16 },
        sm: { span: 16 }
    }
}
interface state {
    loading: boolean
    submitLoading: boolean
}
const state = reactive<state>({
    loading: false,
    submitLoading: false,
})
interface FormStateIface {
    id: number
    status: number
    remark: string
}
const formState = reactive<FormStateIface>({
    id: 0,
    status: 1,
    remark: ''
})
onMounted(() => {
    //直接显示props
    formState.id = props.detailData.id
})
const onFormSubmit = () => {
    state.submitLoading = true
    let requestParam = {
        url: '/admin/v1/publicARecharge/audit',
        method: 'post',
        data: formState
    }
    baseService(requestParam)
        .then((res: any) => {
            message.success(res.msg)
            emit('ok')
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败,请联系管理员')
            }
        })
        .finally(() => {
            state.submitLoading = false
        })
}
const cancel = () => {
    emit('cancel')
}
</script>
<style lang="less" scoped></style>
